<template>
  <div class="registerForm">
    <h4>JESTEM NOWYM KLIENTEM</h4>
    <ValidationObserver tag="div" ref="registerForm" >

      <ValidationProvider tag="div" class="form-group" mode="lazy" rules="asyncRule|required"
                          v-slot="{ errors, dirty, valid, classes, validated }">
        <div>
          <label for="registerName" class="required">Nazwa użytkownika:</label>
          <input
            @change="handleInputChange"
            class="form-control"
            :class="classes"
            :disabled="isInputDisabled"
            type="text"
            name="registerName"
            id="registerName"
            v-model="username"
          >
        </div>
        <ul class="errors">
          <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
        </ul>
      </ValidationProvider>

      <ValidationProvider tag="div" class="form-group" name="registerPassword"
                          rules="required|passwordStrength" v-slot="{ errors, dirty, valid , classes }">
        <div>
          <label for="registerPassword" class="required">Hasło:</label>
          <input
            @change="handleInputChange"
            class="form-control"
            :class="classes"
            :disabled="isInputDisabled"
            type="password"
            name="registerPassword"
            id="registerPassword"
            v-model.lazy="usernamePassword">
        </div>
        <ul class="errors">
          <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
        </ul>
      </ValidationProvider>

      <ValidationProvider tag="div" ref="secondPassword" class="form-group"
                          rules="required|password:registerPassword"
                          v-slot="{ errors, dirty, valid , classes }">
        <div>
          <label for="registerPasswordSecond" class="required">Potwierdź hasło:</label>
          <input
            class="form-control"
            @change="handleInputChange"
            :class="classes"
            :disabled="isInputDisabled"
            type="password"
            name="registerPasswordSecond"
            id="registerPasswordSecond"
            v-model.lazy="registrationPasswordSecond">
        </div>
        <ul class="errors">
          <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
        </ul>
      </ValidationProvider>

      <ValidationProvider tag="div" ref="usernameAgreement" class="registerForm__agreements"
                          :rules="{ required: { allowFalse: false } }" v-slot="{ errors, dirty, valid , classes }"
                          name="usernameAggreements" >
        <div>
          <label class="checkbox-inline required" :class="errors.length > 0 ? 'invalid' : ''">
            <input
              type="checkbox"
              v-model="usernameAggreements"
              name="usernameAgreement"
              :disabled="isInputDisabled"
              @change="handleInputChange"
            >
            Oświadczam, że zapoznałem się z <a target="_blank" href="/docs/Regulamin.pdf"><strong>Regulaminem Sklepu Pluxee</strong></a> oraz
            <a target="_blank" v-if="getProductType === 'EC_ISS'" href="/docs/Regulamin_kart.pdf"><strong>Regulaminem Systemu Kart</strong></a>
            <a target="_blank" v-if="getProductType === 'V_ISS'" href="/docs/Regulamin_kuponów.pdf"><strong>Regulaminem Systemu Kuponów</strong></a>
            i akceptuję ich treść.
          </label>
        </div>
        <ul class="errors">
          <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
        </ul>
      </ValidationProvider>

      <p>Na podany adres e-mail zostanie wysłana wiadomość z prośbą o potwierdzenie rejestracji. Kliknij w link weryfikacyjny, aby potwierdzić rejestrację. Po otrzymaniu potwierdzenia przeprowadzimy szybki proces weryfikacji (jeśli jesteś już naszym klientem i masz potwierdzone specjalne warunki handlowe, zostaną one uwzględnione na Twoim profilu).  O dokończeniu procesu weryfikacji poinformujemy Cię drogą mailową.</p>
      <p>Kliknij „Kontynuuj”, aby dokończyć proces składania zamówienia.</p>
    </ValidationObserver>
    <slot name="controls"></slot>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'RegisterFormWrapper',
  data() {
    return {
      username: '',
      usernamePassword: '',
      usernameAggreements: false,
      registrationPasswordSecond: '',
      isFormSended: false,
      isInputDisabled: false,
    };
  },
  created() {
    this.username = this.registrationUsername;
    this.usernamePassword = this.registrationPassword;
    this.usernameAggreements = this.isRegistrationAgreementsChecked;
  },
  computed: {
    getRegistrationFromData() {
      return {
        userName: this.registerName,
        userPassword: this.registerPassword,
        isAgreementChecked: this.registerAgreement,
      };
    },
    isFormFilled() {
      return (this.username.length && this.registrationPasswordSecond.length && this.usernamePassword.length && this.usernameAggreements);
    },
    getProductType() {
      return this.$store.getters.getProductType;
    },
    ...mapState('registration', ['registrationUsername', 'registrationPassword', 'isRegistrationAgreementsChecked']),
  },
  methods: {
    handleInputChange(e) {
      const { value } = e.target;
      const inputName = e.target.name;

      switch (inputName) {
        case 'registerName':
          this.$store.dispatch('registration/handleRegistrationUsernameChanged', value);
          break;

        case 'registerPasswordSecond':
          this.$store.dispatch('registration/handleRegistrationPasswordChanged', value);
          break;

        case 'usernameAggreements':
          this.$store.dispatch('registration/handleRegistrationAgreementsChanged', e.target.checked);
          break;

        default:
          break;
      }
    },
    fireNotify() {
      this.$notify({
        type: 'success',
        title: 'Formularz wysłano pomyślnie',
        content: 'Sprawdź swoją skrzynkę mailową!',
        duration: 2000,
      });
    },
    clearForm() {
      this.registerName = '';
      this.registerPassword = '';
      this.registerPasswordSecond = '';
      this.isFormSended = false;
      this.registerAgreement = false;
      this.isInputDisabled = true;
      this.$refs.registerForm.reset();
    },
  },
};
</script>

<style scoped lang="scss">

  input.valid {
    color: #3c763d;
    border: 1px solid #3c763d;
    background-color: #dff0d8;
  }

  input.invalid {
    color: #a94442;
    border: 1px solid #a94442;
    background-color: #f2dede;
  }

</style>
